
import { defineComponent } from "vue";
import "@/assets/scss/patient/profile.scss";
import axios from "axios";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "profile-doctor",
  data() {
    return {
      first_name: "",
      last_name: "",
      birthday: "",
      address: "",
      national_code: "",
      mobile: "",
      gender: "",
      show: false,
      showEdit: true,
      isEditing: false,
    };
  },
  methods: {
    fetchProfile() {
      axios
        .get("/doctor")
        .then((res) => {
          console.log(res);
          if (res.data.doctor.id) {
            this.first_name = res.data.doctor.first_name;
            this.last_name = res.data.doctor.last_name;
            this.birthday = res.data.doctor.birthday;
            this.address = res.data.doctor.address;
            this.national_code = res.data.doctor.national_code;
            this.mobile = res.data.doctor.mobile;
          }
        })
        .catch((error) => {
          console.log(error.status);
        });
    },
    close() {
      this.showEdit = true;
      this.show = false;
      this.isEditing = false;
    },
    edit() {
      this.show = true;
      this.showEdit = false;
      this.isEditing = true;
    },
  },
  mounted() {
    this.fetchProfile();
  },
});
